module.exports = __webpack_public_path__ + "static/img/commodity.cbfcb2a3.png";